var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostEffectiveness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 70,
    viewBox: "0 0 47 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h47v70H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#010ED0",
    mask: "url(#b)",
    d: "M20.43 53.56v7.64l-2.91 2.13 5.87 5.64 6.31-12.99-3.01.78v-6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 49.04c8 0-6.77-5.43-6.08-27.43.7-22 16.99-25.88 8.38-26.18C13.4-4.87 5.56 3.1 4.8 22.14c-.55 13.46 6.9 26.9 14.9 26.9Z",
    fill: "#DEE0FF",
    mask: "url(#b)",
    transform: "rotate(29 14.63 22.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 51.26.19.19a9.93 9.93 0 0 0 6.71 2.33c.35 0 .71-.05 1.07-.07l.03 7.08-3.1 1.79a.73.73 0 0 0-.1 1.18l7.14 6.19c.35.3.92.2 1.13-.23l7.09-14.4a.73.73 0 0 0-1.02-.95l-2.37 1.37-.02-5.02c10.24-6.28 18.5-20.84 18.46-32.7-.01-6-2.1-10.5-5.87-12.69l-.06-.02-6.52-3.8c-3.8-2.22-8.81-1.76-14.09 1.3a.73.73 0 0 0 .73 1.26c4.8-2.79 9.29-3.25 12.63-1.3l2.07 1.2c-3.07 0-6.17 1.15-8.84 2.67C16.36 12.34 8.41 25.58 7.3 37c-.34 3.58-.07 8.04 1.52 11.28l.01.03-1.68-.98c-3.3-1.93-5.11-6-5.12-11.46-.03-8.4 4.29-18.5 11-25.77a.73.73 0 1 0-1.07-.99C5 16.63.54 27.13.56 35.87c.02 6 2.1 10.52 5.85 12.72l4.6 2.67Zm17.79 5.57-5.61 11.4-5.66-4.9 2.57-1.48a.73.73 0 0 0 .37-.64l-.03-7.65c1.72-.28 3.94-1 5.86-2l.03 5.44a.73.73 0 0 0 1.1.63l1.37-.8Zm15.96-38.81c.03 13.65-11.96 32.5-25.15 34.18-3.9.51-7.26-.61-9.22-4.1-1.7-3.07-1.97-7.52-1.62-11.05 1.06-10.88 8.73-23.65 18.2-29.13L27 7.9c3.88-2.22 8.68-3.53 12.56-1.33l.06.03h.01c3.3 1.92 5.12 5.97 5.13 11.42Z",
    fill: "#000",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.73 4.76a34.9 34.9 0 0 0-2.44 2.03.73.73 0 1 0 .98 1.08c.76-.7 1.54-1.35 2.33-1.94a.73.73 0 1 0-.87-1.17Z",
    fill: "#000",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28 13.42c-7.32 4.22-13.25 14.5-13.22 22.9.02 8.73 6.4 12.43 14.03 8.02 7.32-4.22 13.24-14.5 13.22-22.92-.02-8.72-6.4-12.4-14.03-8Zm.09 29.66c-6.7 3.86-11.83.8-11.86-6.77-.02-7.93 5.59-17.63 12.5-21.63 6.65-3.84 11.83-.85 11.85 6.74.02 7.95-5.59 17.67-12.5 21.66Z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.66 28.09c-.66-.38-1.51-.32-2.34.16-.36.2-.7.26-.89.16-.18-.11-.3-.42-.3-.83 0-1.2.87-2.7 1.9-3.3.37-.2.7-.27.89-.16.19.11.3.42.3.84a.73.73 0 0 0 1.46 0c0-.96-.38-1.73-1.03-2.1-.36-.21-.8-.27-1.24-.22v-1.42a.73.73 0 0 0-1.46 0v2.05a5.78 5.78 0 0 0-2.27 4.3c0 .96.38 1.72 1.03 2.1.66.37 1.51.32 2.35-.17.36-.2.69-.26.88-.16.18.11.3.42.3.84 0 1.18-.86 2.68-1.9 3.28-.36.21-.7.27-.88.16-.2-.1-.3-.41-.3-.82 0-.4-.33-.73-.74-.73-.4 0-.73.33-.73.73 0 .95.38 1.71 1.03 2.09.3.16.61.24.96.24.09 0 .18-.03.27-.04v1.45a.73.73 0 0 0 1.46 0v-2.05a5.74 5.74 0 0 0 2.29-4.31c0-.96-.39-1.72-1.04-2.1Z",
    fill: "#000",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostEffectiveness);
export default __webpack_public_path__ + "static/media/Cost-effectiveness.6b6421e8f6cd4f1867ed60754a3db9ca.svg";
export { ForwardRef as ReactComponent };